import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityStatsPanel = ({ logs }) => {
  // Calculate statistics
  const totalActivities = logs?.length || 0;
  const successfulActivities = logs?.filter(log => log?.status === 'Success')?.length || 0;
  const failedActivities = logs?.filter(log => log?.status === 'Failed')?.length || 0;
  const criticalEvents = logs?.filter(log => log?.severity === 'Critical')?.length || 0;
  const warningEvents = logs?.filter(log => log?.severity === 'Warning')?.length || 0;
  
  const successRate = totalActivities > 0 ? ((successfulActivities / totalActivities) * 100)?.toFixed(1) : 0;

  // Most active module
  const moduleCounts = logs?.reduce((acc, log) => {
    acc[log?.moduleUsed] = (acc?.[log?.moduleUsed] || 0) + 1;
    return acc;
  }, {});
  const mostActiveModule = Object.keys(moduleCounts || {})?.reduce((a, b) => 
    (moduleCounts?.[a] || 0) > (moduleCounts?.[b] || 0) ? a : b, 'N/A'
  );

  const stats = [
    {
      label: 'Total Activities',
      value: totalActivities,
      icon: 'Activity',
      color: 'text-blue-600',
      bgColor: 'bg-blue-100',
      borderColor: 'border-blue-200'
    },
    {
      label: 'Success Rate',
      value: `${successRate}%`,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20'
    },
    {
      label: 'Failed Activities',
      value: failedActivities,
      icon: 'XCircle',
      color: 'text-destructive',
      bgColor: 'bg-destructive/10',
      borderColor: 'border-destructive/20'
    },
    {
      label: 'Critical Events',
      value: criticalEvents,
      icon: 'AlertTriangle',
      color: 'text-purple-600',
      bgColor: 'bg-purple-100',
      borderColor: 'border-purple-200'
    },
    {
      label: 'Warnings',
      value: warningEvents,
      icon: 'AlertCircle',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20'
    },
    {
      label: 'Most Active Module',
      value: mostActiveModule,
      icon: 'TrendingUp',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 elevation-sm hover:elevation-md transition-smooth"
        >
          <div className="flex items-center justify-between mb-2">
            <div className={`w-10 h-10 rounded-lg ${stat?.bgColor} border ${stat?.borderColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
          </div>
          <p className="text-xs text-muted-foreground font-caption mb-1">{stat?.label}</p>
          <p className="text-xl md:text-2xl font-bold text-foreground font-heading">{stat?.value}</p>
        </div>
      ))}
    </div>
  );
};

export default ActivityStatsPanel;